export default __webpack_public_path__ + "1b383b4aec74b27f0c042358ce99fe91.svg";